import React, { useEffect, useState } from 'react'
import { Button, Container } from '@mui/material'
import '../App.css'
import '../index.css'
import logger from '../utils/logger'

function CategorySelector({ categoryHandler, categories }) {
	const [selectedType, setSelectedType] = useState()
	//const [categories, setCategories] = useState([])

	const handlerClick = (id, name, fileName) => {
		logger.log('id:', id, ' name:', name, '🎨 fileds:', fileName)
		setSelectedType(id)
		categoryHandler(id, name, fileName)
	}

	


	return (
		<div className='mt-5'>
			
			<div className=''>
				{categories.map(category => (
					<div key={category.id}>
						<h2 className='text-base mt-2'>{category.name}</h2>
						{category.subcategories.map(subcategory => (
							<Button
								variant={
									selectedType === subcategory.id ? 'contained' : 'outlined'
								}
								
								key={subcategory.id}
								sx={{ textTransform: 'none', mt: 1, mr: 1 }}
								onClick={() => handlerClick(subcategory.id, subcategory.name, subcategory.fields)}
							>
								{subcategory.name}
							</Button>
						))}
					</div>
				))}
			</div>
		</div>
	)
}

export default CategorySelector
